import { useState } from "react";
import { Modal, Button, Form, Input } from "antd";
import { withRouter } from "react-router";
import { createConstant } from "@api/workspace/constant";
import { SuccessNotification, ErrorNotification } from "../..";

const initialState = {
  name: "",
  value: "",
};

const ConstantCreateModal = ({ open, handleModalClick, fetchConstants }) => {
  const [values, setValues] = useState(initialState);
  const [loading, setLoading] = useState(false);

  // Handle form change
  const handleFormChange = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  // Handle constant create
  const handleConstantCreate = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Create a new constant for the admin
    createConstant(values)
      .then(() => {
        setValues(initialState);
        handleModalClick();
        fetchConstants();
        SuccessNotification("Constant created successfully");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorNotification(err.response.data.message);
      });
  };

  return (
    <>
      <Modal
        title="Create Constant"
        visible={open}
        onOk={handleModalClick}
        closable={false}
        width={600}
        footer={[
          <Button key="back" onClick={handleModalClick}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleConstantCreate}
            loading={loading}
          >
            Create
          </Button>,
        ]}
      >
        <Form
          labelCol={{
            span: 5,
          }}
          wrapperCol={{
            span: 16,
          }}
        >
          {/* Constant Name */}
          <Form.Item label="Name">
            <Input
              name="name"
              placeholder="Enter constant name"
              onChange={handleFormChange}
              value={values.name}
              rules={[{ required: true }]}
            />
          </Form.Item>

          {/* Constant Value */}
          <Form.Item label="Value">
            <Input
              name="value"
              placeholder="Enter constant value"
              onChange={handleFormChange}
              value={values.value}
              rules={[{ required: true }]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default withRouter(ConstantCreateModal);
